import { useQuery, useMutation } from 'react-query';
import { NotificationManager } from 'react-notifications';
import { fieldAPI } from '../field-controller';

export const useAPI = ({ neLng, neLat, swLng, swLat }, zoom) => {
  const { isIdle, isLoading, error, refetch, data } = useQuery(
    ['fields', { neLng, neLat, swLng, swLat, zoom }],
    () => fieldAPI.all({ neLng, neLat, swLng, swLat, zoom }),
    {
      keepPreviousData: true,
      onError: (error) => {
        NotificationManager.error(error.message);
      },
    },
  );

  return { isLoading, isIdle, error, refetch, data };
};

export const useGetAllAPI = ({ page, size, sort }) => {
  const { isIdle, isLoading, error, refetch, data } = useQuery(
    ['fields', { page, size, sort }],
    () => fieldAPI.pageableAll({ page, size, sort }),
    {
      keepPreviousData: true,
      onError: (error) => {
        NotificationManager.error(error.message);
      },
    },
  );

  return { isLoading, isIdle, error, refetch, data };
};

export const useGetAPI = ({ id }) => {
  const { isLoading, error, data } = useQuery(['field', { id }], () => fieldAPI.get(id), {
    onError: (error) => {
      NotificationManager.error(error.message);
    },
  });

  return { isLoading, error, data };
};

export const useCreateAPI = () => {
  const { mutate, isLoading, isSuccess, error, data } = useMutation(
    ({ coordinates }) => fieldAPI.create({ coordinates }),
    {
      onSuccess: () => {
        NotificationManager.success('', 'Поле создано!');
      },
      onError: (error) => {
        NotificationManager.error(error.message, 'Ошибка создания поля!');
      },
    },
  );
  return { isLoading, isSuccess, error, data, mutate };
};

export const useUpdateAPI = () => {
  const { mutate, isLoading, isSuccess, error, data } = useMutation(
    ({ id, coordinates, name }) => fieldAPI.update({ id, coordinates, name }),
    {
      onSuccess: () => {
        NotificationManager.success('', 'Поле изменено!');
      },
      onError: (error) => {
        NotificationManager.error(error.message, 'Ошибка изменения поля!');
      },
    },
  );
  return { isLoading, isSuccess, error, data, mutate };
};

export const useDeleteAPI = () => {
  const { mutate, isLoading, isSuccess, error, data } = useMutation(
    ({ id }) => fieldAPI.delete({ id }),
    {
      onSuccess: () => {
        NotificationManager.success('', 'Поле удалено!');
      },
      onError: (error) => {
        NotificationManager.error(error.message, 'Ошибка удаления поля!');
      },
    },
  );
  return { isLoading, isSuccess, error, data, mutate };
};
